import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import keycloak from './keycloak';

keycloak.init({
  onLoad: 'login-required',
  checkLoginIframe: false,
  pkceMethod: 'S256'
}).then(authenticated => {
  if (authenticated) {
    // Token refresh every 60 seconds
    setInterval(() => {
      keycloak.updateToken(70).catch(() => keycloak.logout());
    }, 60000);

    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(<App keycloak={keycloak} />);
  } else {
    keycloak.login();
  }
}).catch(err => {
  console.error('Keycloak init failed:', err);
  document.getElementById('root').innerHTML =
    '<div style="color:red;padding:2rem">Authentication service unavailable. Please try again later.</div>';
});
